module.exports = __webpack_public_path__ + "static/media/logo-yourviews.0b64066e.png";